// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Regexps to identify product groups by internal calculator sku code.
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
const regexps = {
    membranes: /^_[0-9A-F]{4}_M(?<type>[A-Z])_(?<thickness>\d{3})_(?<width>\d{4})$/,
    adhesives: /^_[0-9A-F]{4}_A(?<type>[A-Z])(?<membrane>[A-Z])(?<application>[A-Z])_(?<volume>\d{4})$/,
    tapes: /^_[0-9A-F]{4}_T(?<type>[A-Z])(?<shape>[A-Z])_(?<width>\d{4})_(?<length>\d{4})$/,
    trims: /^_[0-9A-F]{4}_E(?<type>[A-Z])(?<material>[A-Z])(?<color>[A-Z])_(?<length>\d{3})$/,
    corners: /^_[0-9A-F]{4}_C(?<corner>[A-Z])(?<type>[A-Z])(?<material>[A-Z])(?<color>[A-Z])$/,
    drains: /^_[0-9A-F]{4}_D(?<type>[A-Z]{2})_(?<width>\d{3})_(?<height>\d{3})_(?<length>\d{3})$/,
    extras: /^_[0-9A-F]{4}_X(?<type>[A-Z])(?<category>[A-Z]{3})_(?<code>\d{3})$/,
    kits: /^_[0-9A-F]{4}_K(?<type>[A-Z]{2})_(?<width>\d{4})$/
}

// @@exports
export { regexps }
